import React from 'react';
import enhance from './DealsOverviewTable.enhancer';
import Typography from '@material-ui/core/Typography';
import { Grid } from '@material-ui/core';
import { filter } from 'lodash';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import { dealStatuses } from '../../../constants';
import moment from 'moment';
import LinkText from '../../shared/components/LinkText';
import axios from 'axios';

class DealsOverviewTable extends React.Component {
  constructor() {
    super();

    this.initialState = {
      completedDeals: [],
      count: 0,
      currentPage: 0,
      dataWasLoaded: false
    };

    this.state = {
      ...this.initialState
    };
  }

  componentWillMount() {
    if (this.props.dealList) {
      this.loadData(this.props.dealList);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.dealList &&
      nextProps.dealList.length &&
      !this.state.completedDeals.length &&
      !this.state.dataWasLoaded
    ) {
      this.loadData(nextProps.dealList);
    }
  }

  loadData(dealList) {
    this.setState({
      dataWasLoaded: true
    });
    this.props.firebase
      .auth()
      .currentUser.getIdToken(false)
      .then(idToken => {
        return axios
          .post(`${process.env.REACT_APP_FIREBASE_URL}/getContentViews`, {
            idToken
          })
          .then(res => {
            if (res.status == 200 && res.data) {
              const dealContent = res.data;
              const offeredDeals = filter(
                dealList,
                mp => mp.status === dealStatuses.COMPLETE
              );
              const dealPromises = offeredDeals.map(deal => {
                return new Promise(resolve => {
                  const userId = this.props.isCompany
                    ? deal.influencerId
                    : deal.companyId;
                  return this.props.firestore
                    .get({
                      collection: 'users',
                      doc: userId
                    })
                    .then(user => {
                      const userData = user.data();
                      return this.props.firestore
                        .get({
                          collection: 'campaigns',
                          storeAs: 'overviewCampaign',
                          doc: deal.campaignId
                        })
                        .then(camp => {
                          const campData = camp.data();
                          const dealContents = dealContent.find(
                            dc => dc.dealId === deal.id
                          );
                          const dealContentViews = dealContents
                            ? dealContents.totalViews
                            : 0;
                          resolve({
                            ...deal,
                            campaign: { ...campData, id: camp.id },
                            user: { ...userData, id: user.id },
                            views: dealContentViews
                          });
                        });
                    });
                });
              });

              Promise.all(dealPromises).then(deals => {
                this.setState({
                  completedDeals: deals,
                  count: deals.length,
                  tableRows: deals.slice(0, 10)
                });
              });
            }
          })
          .catch(err => {
            console.log(err);
          });
      });
  }

  handleChangePage(event, newPage) {
    const rowStart = newPage * 10;
    this.setState({
      currentPage: newPage,
      tableRows: this.state.completedDeals.slice(rowStart, rowStart + 10)
    });
  }

  navigateToCampaign(campaignId) {
    this.props.history.push(`/campaigns/${campaignId}`);
  }

  navigateToProfile(userId) {
    this.props.history.push(`user/${userId}/profile`);
  }

  render() {
    const { classes, forCompany } = this.props;
    const { completedDeals, count, currentPage } = this.state;

    return (
      <React.Fragment>
        <Paper className={classes.root}>
          <Table className={classes.table}>
            <TableBody>
              <TableRow>
                <TableCell className={classes.headerCell}>Date</TableCell>
                <TableCell className={classes.headerCell}>
                  Campaign Title
                </TableCell>
                <TableCell className={classes.headerCell}>
                  {forCompany ? 'Influencer' : 'company'}
                </TableCell>
                <TableCell className={classes.headerCell}>Reach</TableCell>
                <TableCell className={classes.headerCell}>Commission</TableCell>
              </TableRow>
              {completedDeals &&
                completedDeals.length > 0 &&
                completedDeals.map(row => (
                  <TableRow key={row.id} className={classes.tableRow}>
                    <TableCell
                      component="th"
                      scope="row"
                      className={classes.tableCell}
                    >
                      {moment(row.currentProposal.dueDate.toDate()).format(
                        'MM/DD/YYYY'
                      )}
                    </TableCell>
                    <TableCell
                      component="th"
                      scope="row"
                      className={classes.tableCell}
                    >
                      <LinkText
                        onClick={() => this.navigateToCampaign(row.campaign.id)}
                      >
                        {row.campaign.name}
                      </LinkText>
                    </TableCell>
                    <TableCell
                      component="th"
                      scope="row"
                      className={classes.tableCell}
                    >
                      <LinkText
                        onClick={() => this.navigateToProfile(row.user.id)}
                      >
                        {row.user.displayName}
                      </LinkText>
                    </TableCell>
                    <TableCell
                      component="th"
                      scope="row"
                      className={classes.tableCell}
                    >
                      {row.views}
                    </TableCell>
                    <TableCell
                      component="th"
                      scope="row"
                      className={classes.tableCell}
                    >
                      {row.currentProposal.payout.toLocaleString()}
                    </TableCell>
                  </TableRow>
                ))}
              {(!completedDeals || !completedDeals.length) && (
                <TableRow>
                  <TableCell colSpan={5}>
                    <Typography align="center" variant="h6">
                      No Completed Deals
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
            <TablePagination
              component="div"
              count={count}
              rowsPerPage={10}
              page={currentPage}
              backIconButtonProps={{
                'aria-label': 'Previous Page'
              }}
              nextIconButtonProps={{
                'aria-label': 'Next Page'
              }}
              onChangePage={this.handleChangePage.bind(this)}
            />
          </Table>
        </Paper>
      </React.Fragment>
    );
  }
}

export default enhance(DealsOverviewTable);



// WEBPACK FOOTER //
// ./src/components/dashboard/shared/DealsOverviewTable.js